// Iter326 · Claire Context Hook.
// Pages call `useClaireContext({...})` so the Claire widget picks up
// the current filters/selected entity/visible count without touching
// a shared store. The context is written to `window.__claireContext`
// and cleared on unmount so a stale filter never bleeds to a new page.
import { useEffect } from "react";

export function useClaireContext(ctx) {
  useEffect(() => {
    try {
      window.__claireContext = ctx || null;
    } catch (_e) { /* ignore */ }
    return () => {
      try { window.__claireContext = null; } catch (_e) { /* ignore */ }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(ctx || {})]);
}
